<template>
  <div class="app">
    <div
      class="careers content-container content-container--narrow"
      :class="{ 'careers--min-height-100vh' : isFilterOpen }"
    >
      <CareerSearch @togglePageHeader="togglePageHeader" />
      <CareerResults />
    </div>
  </div>
</template>

<script>

import CareerSearch from '@/components/CareerSearch.vue'
import CareerResults from '@/components/CareerResults.vue'

export default {
  name: 'Careers',
  components: {
    CareerSearch,
    CareerResults
  },
  data () {
    return {
      isFilterOpen: false,
      pageHeader: document.querySelector('[data-section-header-careers]')
    }
  },
  methods: {
    togglePageHeader (status) {
      this.isFilterOpen = status
      if (this.isFilterOpen) {
        this.pageHeader.classList.add('section-header-careers--closed')
        window.scrollTo(0, 0)
      } else {
        this.pageHeader.classList.remove('section-header-careers--closed')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@use 'mixins' as *;
@use 'variables';

.app {
  position: relative;
}

.careers {
  display: flex;
  flex-direction: column;
  position: relative;
  padding-bottom: 2rem;

  @include mobile-only {
    padding-left: 0;
    padding-right: 0;
  }

  @include breakpoint-md {
    flex-direction: row;
  }

  &--min-height-100vh{
    min-height: 100vh;
  }
}
</style>
